import React, { memo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import useMediaQuery from '@mui/material/useMediaQuery'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid2'
import EasyButton from 'components/Easy/EasyButton'
import Easyhowworks from 'apps/Easy/Easyhowworks'
import EasyhowworksMobile from 'apps/Easy/EasyhowworksMobile'
import Image from 'components/shared/Image'
import MainEasyImage from 'public/img/easy/how_its_works.webp'
import EasyAgenciasMainImage from 'public/img/easy/img_mobile@2x-min.webp'
import EasyWhatsappLink from 'components/Easy/EasyWhatsappLink/EasyWhatsappLink'
import sx from './styles'

function ThisIsWhatWeDo(props) {
  const {
    title = 'EASY_THIS_IS_WHAY_WILL_DO_TITLE',
    subtitle = 'EASY_WE_DO_EVERYTHING_FOR_YOU',
    isEasyAgencias = false,
    onClickButton,
    onClickWhatsappButton,
    showWhatsappButton = false,

  } = props
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'))
  const { formatMessage: f } = useIntl()

  const items = [
    {
      id: 1,
      title: isEasyAgencias ? 'EASY_AGENCIAS_NEW_CHANNEL_TITLE_1' : 'EASY_OUR_MISION_ITEM_TITLE_1',
      description: isEasyAgencias ? 'EASY_AGENCIAS_NEW_CHANNEL_SUBTITLE_1' : 'EASY_OUR_MISION_ITEM_DESCRIPTION_1',
    },
    {
      id: 2,
      title: isEasyAgencias ? 'EASY_AGENCIAS_NEW_CHANNEL_TITLE_2' : 'EASY_OUR_MISION_ITEM_TITLE_2',
      description: isEasyAgencias ? 'EASY_AGENCIAS_NEW_CHANNEL_SUBTITLE_2' : 'EASY_OUR_MISION_ITEM_DESCRIPTION_2',
    },
    {
      id: 3,
      title: isEasyAgencias ? 'EASY_AGENCIAS_NEW_CHANNEL_TITLE_3' : 'EASY_OUR_MISION_ITEM_TITLE_3',
      description: isEasyAgencias ? 'EASY_AGENCIAS_NEW_CHANNEL_SUBTITLE_3' : 'EASY_OUR_MISION_ITEM_DESCRIPTION_3',
    },
    {
      id: 4,
      title: isEasyAgencias ? 'EASY_AGENCIAS_NEW_CHANNEL_TITLE_4' : 'EASY_OUR_MISION_ITEM_TITLE_4',
      description: isEasyAgencias ? 'EASY_AGENCIAS_NEW_CHANNEL_SUBTITLE_4' : 'EASY_OUR_MISION_ITEM_DESCRIPTION_4',
    },
  ]

  return (
    <Grid
      id="Comofunciona"
      container
      sx={sx.root}
    >
      <Grid
        size={12}
        container
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <Typography
          sx={sx.title}
          component="h2"
          textAlign="center"
          variant="h1"
        >
          <FormattedMessage
            id={title}
          />
        </Typography>

        <Typography
          component="h3"
          sx={sx.subtitle}
          textAlign="center"
          variant="h2"
        >
          <FormattedMessage id={subtitle} />
        </Typography>

      </Grid>

      {isMobile ? (
        <Image
          title={f({ id: 'EASY_THIS_IS_WHAY_WILL_DO_TITLE' })}
          src={isEasyAgencias ? EasyAgenciasMainImage : MainEasyImage}
          fill
          placeholder="blur"
          alt={f({ id: 'EASY_THIS_IS_WHAY_WILL_DO_TITLE' })}
          width="100%"
          height="395px"
          priority
          unoptimized
        />
      )
        : (
          <Image
            title={f({ id: 'EASY_THIS_IS_WHAY_WILL_DO_TITLE' })}
            sx={sx.imageDesk}
            src={isEasyAgencias ? EasyAgenciasMainImage : MainEasyImage}
            fill
            placeholder="blur"
            alt={f({ id: 'EASY_THIS_IS_WHAY_WILL_DO_TITLE' })}
            width="416px"
            height="395px"
            priority
            unoptimized
          />
        )}

      {isMobile
        ? <EasyhowworksMobile items={items} />
        : <Easyhowworks items={items} />}

      <Grid
        size={12}
        mb={9}
        sx={sx.cts}
      >
        <EasyButton
          showIcon={!isEasyAgencias}
          cta={isEasyAgencias ? 'EASY_IM_INTERESTED' : 'EASY_MAIN_CTA'}
          handleClick={onClickButton}
        />
        {showWhatsappButton && (
          <EasyWhatsappLink onClickWhatsapp={onClickWhatsappButton} />
        )}

      </Grid>
    </Grid>
  )
}

export default memo(ThisIsWhatWeDo)
